import { BackendError } from './base';
import General from './general';

class BillingDiscountInWeekend extends BackendError {}
class BillingDoesNotExist extends General.NotFound {}
class BillingNotPayableByCC extends BackendError {}
class BillingValueMustBePositive extends BackendError {}
class CannotCreateWithdrawalRequest extends BackendError {}
class DimobReportRequestRateLimit extends BackendError {}
class DuplicatedAddressRentalContract extends BackendError {}
class IncorrectBillingStatus extends BackendError {}
class InvalidBillingDiscounts extends BackendError {}
class InvalidBillingFine extends BackendError {}
class InvalidBillingValue extends BackendError {}
class InvalidCreci extends BackendError {}
class InvoiceDoesNotExist extends General.NotFound {}
class InvoiceGenerationNotAvailable extends BackendError {}
class InvalidPaymentSlipMinValue extends BackendError {}
class KYCDataProviderError extends BackendError {}
class RentalChargeDuplicatedRent extends BackendError {}
class RentalChargeNotFound extends General.NotFound {}
class RentalContractDoesNotExist extends General.NotFound {}
class RentalLandlordCannotBeRemoved extends General.NotFound {}
class RentalLandlordNotFound extends General.NotFound {}
class RentalLandlordPropertyCannotBeRemoved extends General.NotFound {}
class RentalReportRequestRateLimit extends BackendError {}
class SplitDiscriminationNotFound extends General.NotFound {}
class SplitDoesNotExist extends General.NotFound {}
class SplitInstallmentAlreadyApproved extends BackendError {}
class SplitValueCannotBeNegative extends BackendError {}
class WorkspaceInfoNeeded extends BackendError {}

export default {
    BillingDiscountInWeekend,
    BillingDoesNotExist,
    BillingNotPayableByCC,
    BillingValueMustBePositive,
    CannotCreateWithdrawalRequest,
    DimobReportRequestRateLimit,
    DuplicatedAddressRentalContract,
    IncorrectBillingStatus,
    InvalidBillingDiscounts,
    InvalidBillingFine,
    InvalidBillingValue,
    InvalidCreci,
    InvoiceDoesNotExist,
    InvoiceGenerationNotAvailable,
    InvalidPaymentSlipMinValue,
    KYCDataProviderError,
    RentalChargeDuplicatedRent,
    RentalChargeNotFound,
    RentalContractDoesNotExist,
    RentalLandlordCannotBeRemoved,
    RentalLandlordNotFound,
    RentalLandlordPropertyCannotBeRemoved,
    RentalReportRequestRateLimit,
    SplitDiscriminationNotFound,
    SplitDoesNotExist,
    SplitInstallmentAlreadyApproved,
    SplitValueCannotBeNegative,
    WorkspaceInfoNeeded,
};
